module.exports = __webpack_public_path__ + "fonts/opoli.1b2bb5f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/opoli.ttf?y08y5r
// module id = 1101
// module chunks = 0